export default {
      id: "arrow-left-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#arrow-left-usage",
      toString: function () {
        return this.url;
      }
    }